module.exports = __webpack_public_path__ + "static/media/tripadvisor-logotype.78cb8b29.png";